import { CRM_API, RequestHelper } from "utils";

const RUTA = "terminal_pos";
export const TerminalPOSService = (() => {
  const buscarPorId = function (args, esLookup, requestTracker) {
    return new Promise((res) => res(args)).then((Id, requestTracker) => {
      return RequestHelper(CRM_API).get(`${RUTA}/buscarPorId`, {
        Id: Id,
        esLookup,
      });
    });
  };

  const listado = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get(`${RUTA}/listar`, params);
    });
  };

  const crear = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).post(`${RUTA}/crear`, data);
    });
  };

  const actualizar = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).postWithFiles(`${RUTA}/actualizar`, data);
    });
  };

  const exportar = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).post(`${RUTA}/exportar`, params, true);
    });
  };

  return {
    listado,
    crear,
    actualizar,
    buscarPorId,
    exportar,
  };
})();
